module.exports = __webpack_public_path__ + "static/media/Inter-Thin-BETA.be75564b.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Inter/Inter-Thin-BETA.woff2
// module id = 708
// module chunks = 21